import { FC, memo } from 'react'
import { Box, useToken, useColorModeValue } from '@chakra-ui/react'

type Props = {
  size?: number
  color?: 'primary' | 'gray'
}

const ServicesLetterModuleBrand: FC<Props> = ({ color = 'primary', size = 12 }) => {
  const [primary200, primary300, primary400, primary500, primary600, primary700, primary900, white] = useToken('colors', [
    `${color}.200`,
    `${color}.300`,
    `${color}.400`,
    `${color}.500`,
    `${color}.600`,
    `${color}.700`,
    `${color}.900`,
    'white',
  ])

  const strokeColor900 = useColorModeValue(primary900, primary900)
  const strokenWidth = '40px'
  const fillColor200 = useColorModeValue(primary200, primary300)
  const fillColor400 = useColorModeValue(primary400, primary500)
  const fillColor600 = useColorModeValue(primary600, primary700)
  const fillBG = useColorModeValue(white, white)

  return (
    <Box w={size} h={size} pos="relative">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 800">
        <g id="Cartas_de_Serviços" data-name="Cartas de Serviços">
          <g id="background">
            <g id="group200">
              <path
                fill={fillColor200}
                opacity="0.25"
                d="M776,428s4.21,149.09-89,194c-110,53-120.51,2.17-212,28-85,24-139,84-287,15C129.84,637.89,44.19,533.87,56,463c16-96,57-94,50-161-2.75-26.34-8.77-54.79,9.08-108S197,83,234,69c32.76-12.4,109.89-20.14,175.45,36.4S452.54,222.72,485,236c88,36,118.4,9.89,163,26C684,275,768,325,776,428Z"
              />
            </g>
            <g id="group400">
              <path
                fill={fillColor400}
                opacity="0.2"
                d="M750,456s-8.33,58.76-47.89,70.14c-46.69,13.42-47.41-7.22-85-3.21-35,3.72-60.14,23.64-113.58-13.33-21-14.52-47.63-61.05-38.25-88.06,12.7-36.59,28.65-33.06,30.38-59.81.69-10.51.23-22.07,10.79-41.74s39.57-38.07,55-41.08c13.67-2.67,44.45-.55,66.38,26s9,48.9,20.89,56.28c32.11,20,45.78,11.81,62.2,21.11C724.19,389.86,753.79,415.09,750,456Z"
              />
              <path
                fill={fillColor400}
                opacity="0.2"
                d="M369.5,403.66s-53.43-25.84-52.21-67c1.45-48.56,21.33-43,29-80,7.1-34.42-4.19-64.49,47.31-104.11,20.23-15.57,72.67-26.76,95.54-9.6,31,23.25,22.74,37.37,47.69,47.18,9.81,3.85,21,6.94,36.47,23s24.19,49.28,22.36,64.91c-1.63,13.84-13,42.5-45,55.29s-49.33-6.28-60,2.75c-28.85,24.48-25.2,40-39.06,52.8C440.39,399.22,407.34,419.72,369.5,403.66Z"
              />
              <path
                fill={fillColor400}
                opacity="0.2"
                d="M296.7,654.1s-46.49,36.88-83,17.9c-43.11-22.41-29.42-37.88-59.46-60.87-27.91-21.35-59.9-24.25-73.21-87.85-5.22-25,7.49-77.08,32.89-90.21,34.4-17.79,43.53-4.25,63.21-22.46,7.74-7.16,15.36-15.86,36.57-22.85s54.89-.37,68.18,8.08c11.75,7.48,32.61,30.21,30.23,64.57s-27.11,41.7-23.6,55.21c9.51,36.62,25.08,40.08,30.58,58.13C323.51,588.31,327.61,627,296.7,654.1Z"
              />
            </g>
            <g id="group600">
              <path
                fill={fillColor600}
                d="M707.31,373.33C720.76,412,720.83,454,708.44,493,697.31,528,690,568,628,594c-91.89,38.54-107,9.19-179,38-70,28-136.55,64.23-240,24C137,628,85,562,78,488c-8.81-93.12,28-104,36-150,11.66-67-6.21-82.87,6-127s49.37-61.79,80-72c75-25,104-15,164.84,44.07C415.53,232.28,416,246,437,259c66,40.84,83.56-21.38,182,18C649,289,688,317.88,707.31,373.33Z"
              />
              <path
                fill={fillColor600}
                d="M591.09,136.69c-16.41,8.85-32.38.2-37.19-15.41-4.55-13.88-1.76-41.63,12.55-47.3,14.56-5.77,32.36,14.9,36.21,29.9a35.21,35.21,0,0,1-3.74,25.94A23.75,23.75,0,0,1,591.09,136.69Z"
              />
              <path
                fill={fillColor600}
                d="M739.85,646.94c-1.08,18.56-20.14,27-37.19,29.57-1.88.28-3.71,1.07-5.49,1.33a7.86,7.86,0,0,1-8.62-4.12,34.66,34.66,0,0,1-1.86-5.57c-6.37-21.06-3.27-50.85,22.15-52.79,13.95-1.6,26.7,9.84,30.3,22.59A44.44,44.44,0,0,1,739.85,646.94Z"
              />
              <path
                fill={fillColor600}
                d="M99.68,707.54c-.58,3.66-3.36,6.8-6.49,8.78l-.1.06c-7.82,4.07-17.47,2.35-24.52-2.72a53.21,53.21,0,0,1-21.19-41.19c-.14-4.63,1-10.21,7.07-13.28a13.42,13.42,0,0,1,4.21-1.47C71.31,655.55,102.5,689.8,99.68,707.54Z"
              />
            </g>
          </g>
          <g id="icon">
            <path
              fill={fillBG}
              stroke={strokeColor900}
              strokeWidth={strokenWidth}
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M191.87,346.12V559.57a45.91,45.91,0,0,0,45.92,45.91h321.4a45.9,45.9,0,0,0,45.91-45.91V346.12"
            />
            <path
              fill="none"
              stroke={strokeColor900}
              strokeWidth={strokenWidth}
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M332.38,465l-127,127"
            />
            <path
              fill="none"
              stroke={strokeColor900}
              strokeWidth={strokenWidth}
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M591.58,591.94l-127-127"
            />
            <path
              fill={fillBG}
              stroke={strokeColor900}
              strokeWidth={strokenWidth}
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M260.75,275.39,212.22,308a45.92,45.92,0,0,0,0,76.2L347.07,475a92.05,92.05,0,0,0,102.81,0l134.86-90.73a45.93,45.93,0,0,0,0-76.2l-48.49-32.64"
            />
            <path
              fill={fillBG}
              stroke={strokeColor900}
              strokeWidth={strokenWidth}
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M536.25,402V212.94a23,23,0,0,0-23-23H283.71a23,23,0,0,0-23,23V405"
            />
            <path
              fill="none"
              stroke={strokeColor900}
              strokeWidth={strokenWidth}
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M329.62,272.59H467.37"
            />
            <path
              fill="none"
              stroke={strokeColor900}
              strokeWidth={strokenWidth}
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M329.62,352.94H467.37"
            />
          </g>
        </g>
      </svg>
    </Box>
  )
}

export default memo(ServicesLetterModuleBrand)
